import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WithdrawStore {
  setIsWithdrawTooltipTapped(tooltip: boolean) {
    localStorage.setItem('isWithdrawTooltipTapped', tooltip.toString());
  }

  getIsWithdrawTooltipTapped() {
    return localStorage.getItem('isWithdrawTooltipTapped');
  }

  setIsRefreshTooltipTapped(tooltip: boolean) {
    localStorage.setItem('isRefreshTooltipTapped', tooltip.toString());
  }

  setIsHistoryChecked(checked: boolean) {
    localStorage.setItem('isHistoryChecked', checked.toString());
  }

  getIsHistoryChecked() {
    return localStorage.getItem('isHistoryChecked');
  }

  setWithdrawalHistoryDetails(details: any) {
    localStorage.setItem('withdrawalHistoryDetails', JSON.stringify(details));
  }

  getWithdrawalHistoryDetails() {
    return JSON.parse(localStorage.getItem('withdrawalHistoryDetails'));
  }
}
